<template>
  <content-items-list
    content-type="reports"
    content-type-singular="report"
    content-name="Reports"
    content-name-singular="Report"
  />
</template>

<script>
import ContentItemsList from '@/views/content-item/content-items-list/ContentItemsList.vue'

export default {
  components: {
    ContentItemsList,
  },
}
</script>

<style scoped>

</style>
